export default "__VITE_ASSET__B2Ar_cxZ__"